import { defaultVariant } from '../utils/variants';
export default function useVariants(variants) {
  var parsedVariants = [defaultVariant].concat((Array.isArray(variants) ? variants : [variants]).filter(Boolean));
  return function (key, context) {
    return parsedVariants.map(function (variant) {
      return typeof variant[key] === 'function' ? variant[key](context) : variant[key];
    });
  };
}